import { render } from "./News.vue?vue&type=template&id=3caefd6a&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=3caefd6a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hapi/hapi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caefd6a"]])

export default __exports__